import * as React from 'react';

const SVGLogo: React.SFC<SvgProps> = props => (
  <svg width={30} height={29} {...props}>
    <path
      d="M21.506 12.974a6.442 6.442 0 0 0-.865-2.95l-4.698-8.078A6.472 6.472 0 0 1 15.2 0l-.2.337A6.422 6.422 0 0 0 15 6.8l3.757 6.464a6.422 6.422 0 0 1 0 6.462l-.2.337a6.471 6.471 0 0 0-.742-1.953l-3.432-5.925-2.198-3.768a6.452 6.452 0 0 1-.743-1.954l-.2.337a6.424 6.424 0 0 0-.011 6.442L15 19.725a6.422 6.422 0 0 1 0 6.462l-.2.337a6.471 6.471 0 0 0-.743-1.953l-4.69-8.085a6.44 6.44 0 0 1-.865-3.512C3.474 14.28 0 17.058 0 20.254c0 4.462 6.716 8.08 15 8.08 8.284 0 15-3.618 15-8.08.004-3.196-3.466-5.973-8.494-7.28z"
      fill="#EC0000"
      fillRule="nonzero"
    />
  </svg>
);

export default SVGLogo;
